module.exports = __webpack_public_path__ + "static/app-es@2x-1380ed7dfb9b1f85afe17d97f82a00dc.png";